import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268dff05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-15 white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "../../demo1/dist/index.html",
  class: "mb-10 pt-lg-10"
}, null, -1))
const _hoisted_3 = { class: "pt-lg-10 mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-2qx text-gray-800 mb-7" }, "Verify Your Email", -1))
const _hoisted_5 = { class: "fs-3 fw-bold text-muted mb-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" We have sent an email to ")
const _hoisted_7 = {
  href: "#",
  class: "link-primary fw-bolder"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("please enter the verirfication code below to verify your account ")
const _hoisted_10 = { class: "row d-flex justify-content-center" }
const _hoisted_11 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "text-center mb-10" }
const _hoisted_16 = ["data-kt-indicator"]
const _hoisted_17 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_18 = { class: "indicator-progress" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_21 = { class: "fs-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700" }, "Did’t receive an email? ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px",
  style: {"background-image":"url(assets/media/illustrations/sketchy-1/17.png"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.op.get(_ctx.user, "email", "")), 1),
        _hoisted_8,
        _hoisted_9
      ]),
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        onSubmit: _ctx.verify,
        "validation-schema": _ctx.emailVerificationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.timedOut)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "Time Remaining: " + _toDisplayString(_ctx.timeLeft), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Field, {
                type: "text",
                name: "verificationCode",
                class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                placeholder: "Verification Code",
                autocomplete: "false"
              }),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_ErrorMessage, { name: "verificationCode" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              type: "submit",
              class: "btn btn-lg btn-primary fw-bolder mt-2"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Submit"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_18, [
                _hoisted_19,
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_16)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("a", {
          href: "javascript:void(0)",
          class: "link-primary fw-bolder",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args)))
        }, "Resend")
      ])
    ]),
    _hoisted_23
  ]))
}